import React from 'react';
import { useSelector } from 'react-redux';
import { offersDataSelector } from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import SeoSrpCarousel from '../srp-card/seo-srp-carousel';

const SeoFlightScheduleLeft = props => {
  const offers = useSelector(offersDataSelector);

  return (
    <>
      <SeoSrpCarousel offers={offers} />
    </>
  );
};

export default SeoFlightScheduleLeft;
